import Team from "../entities/Team.js";
import UserJson from "../entities/user/UserJson.js";

export default class TeamRepository {
    #httpClient;
    #endpointUrl;

    constructor(httpClient, endpointUrl = '/api/team') {
        this.#httpClient = httpClient;
        this.#endpointUrl = endpointUrl;
    }

    /**
     * {string} teamId
     * @returns {Promise<Team>}
     */
    async getTeam(teamId) {
        const response = await this.#httpClient
            .fetch(`${this.#endpointUrl}/${teamId}`, {
                method: 'GET',
                headers: {
                    "Accept": "application/json"
                },
                responseType: 'json'
            });
        return Team.parseServerJson(response)
    }

    /**
     * {string} orgId
     * @returns {Promise<Team[]>}
     */
    async getTeamsByOrgId(orgId) {
        const response = await this.#httpClient
            .fetch(`${this.#endpointUrl}?orgId=${orgId}`, {
                method: 'GET',
                headers: {
                    "Accept": "application/json"
                },
                responseType: 'json'
            });
        return Team.parseServerJsonMany(response)
    }

    /**
     * {string} teamId
     * @returns {Promise<UserJson[]>}
     */
    async getTeamMembers(teamId) {
        const response = await this.#httpClient
            .fetch(`${this.#endpointUrl}/${teamId}/members`, {
                method: 'GET',
                headers: {
                    "Accept": "application/json"
                },
                responseType: 'json'
            });
        return UserJson.parseServerJsonMany(response)
    }

    /**
     * {string} teamId
     * {string} userId
     * @returns {Promise<UserJson[]>}
     */
    async removeTeamMember(teamId, userId) {
        await this.#httpClient
            .fetch(`${this.#endpointUrl}/${teamId}/members`, {
                method: 'PATCH',
                headers: {
                    "Content-Type": "application/json"
                },
                responseType: 'json',
                body: JSON.stringify([{"user": userId, "action": "REMOVE"}])
            });
    }

    /**
     * {string} teamId
     * {string[]} userIds
     * @returns {Promise<UserJson[]>}
     */
    async addTeamMembers(teamId, userIds) {
        const body = userIds.map(id => ({"user": id, "action": "ADD"}));
        await this.#httpClient
            .fetch(`${this.#endpointUrl}/${teamId}/members`, {
                method: 'PATCH',
                headers: {
                    "Content-Type": "application/json"
                },
                responseType: 'json',
                body: JSON.stringify(body)
            });
    }
}